import ConsentCanvas from './ConsentCanvas';

export default ConsentCanvas;
